import { FileUIModel } from "src/store/models/ui/file/file";
import { FileItemUIModel } from "src/store/models/ui/file/fileItem";
import { UploadingUIModel } from "src/store/models/ui/file/uploading";

export const fileModels = {
  file: FileUIModel,
  fileItem: FileItemUIModel,
  uploading: UploadingUIModel,
};
